<div class="row">
  <div class="col-lg-12">
    <img [src]="sfondo" class="img-fluid mx-auto d-block" alt="Responsive image" style="width: 100%;">
    <div class="align-items-end usato2">
      USATO
    </div>

    <div class="formRicerca">
      <form role="form" (ngSubmit)="ricerca()" [formGroup]="form">
        <div class="row">
          <div class="col-sm-12">
            <app-conmet-select [formname]="'vclTipologia'" [group]="form" [arr]="tipologie" [val]="'descrizione'"
                               [descr]="'descrizione'" [label]="'Tipologia'" [vuoto]="1"></app-conmet-select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <label>Km percorsi (Da .. a)</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-6">
            <app-conmet-input-number [label]="''" [formname]="'vclKmDa'" [group]="form"></app-conmet-input-number>
          </div>
          <div class="col-sm-6 col-6">
            <app-conmet-input-number [label]="''" [formname]="'vclKmA'" [group]="form"></app-conmet-input-number>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <label>Anno immatr. (Da .. a)</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-6">
            <app-conmet-input-number [label]="''" [formname]="'vclAnnoDa'" [group]="form"></app-conmet-input-number>
          </div>
          <div class="col-sm-6 col-6">
            <app-conmet-input-number [label]="''" [formname]="'vclAnnoA'" [group]="form"></app-conmet-input-number>
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-sm-12">
            <button class="btn btn-success float-right mt-2 ml-2 search-button"  (click)="ricerca()">
              Ricerca
            </button>
          </div>
        </div>
        <div class="row invito">
          <div class="col-sm-12">
            <h1>Clicca sulla ricerca per trovare il veicolo che fa per te!</h1>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="row third-part p-4 m-4">
  <div class="col">    
    <app-veicolo-carousel [veicoli]="inEvidenza"></app-veicolo-carousel>    
  </div>
</div>


<div class="row second-part p-2">
  <div class="col-lg-4">
    <img [src]="img1" class="img-fluid"/>
    <br><br>
    <h3 style="color: #32306f;">ORION usato ricondizionato</h3><a id="ricondizionato"></a>
    <br>
    <span>
      Siamo esperti conoscitori del business dei veicoli di soccorso e capiamo bene le perplessità legate all’acquisto di un veicolo usato, per questo noi di
      ORION non lasciamo niente al caso per poter offrire alla nostra clientela la massima sicurezza e tranquillità. I nostri veicoli usati rispondono a tutti
      gli standard qualitativi imposti dalla legge e, la loro messa in vendita, è preceduta da un lungo ed accurato processo di controllo e ricondizionamento
      dei pezzi usurati.
    </span>
  </div>
  <div class="col-lg-4">
    <img [src]="img2" class="img-fluid"/>
    <br><br>
    <h3 style="color: #32306f;">ORION usato igienizzato</h3><a id="igienizzato"></a>
    <br>
    <span>
      I veicoli in vendita presso Orion sono garantiti, per offrire il massimo della qualità e affidabilità, da meticolosi ed accurati controlli da parte
      del nostro team di meccanici altamente qualificati, ogni mezzo viene inoltre igienizzato con specifiche apparecchiature prima di essere proposti per l’acquisto.
      L’azienda di Calenzano si pone come valido punto di riferimento per tutto il territorio italiano nella vendita dei veicoli per il soccorso usati, grazie alle numerose
      proposte visionabili direttamente presso la sede e disponibili in pronta consegna. Orion tratta sia ambulanze usate che altri mezzi di soccorso e trasporto,
      come auto medicalizzate, veicoli per le forze dell’ordine e la protezione civile, vetture per il trasporto disabili e mezzi con allestimenti speciali.
    </span>
  </div>
  <div class="col-lg-4">
    <img [src]="img3" class="img-fluid"/>
    <br><br>
    <h3 style="color: #32306f;">ORION usato personalizzato</h3><a id="personalizzato"></a>
    <br>
    <span>
      Da Orion potete trovare una vasta gamma di ambulanze usate, mezzi di soccorso in genere, ambulanze di trasporto, ambulanze 4x4, auto mediche,
      veicoli per trasporto sangue e organi, veicolo per trasporto disabili e veicoli per la protezione civile.<br>
      Una volta scelto il veicolo è possibile ricreare personalizzandola l'intera livrea del mezzo.
      I tecnici ORION sono infatti a disposizione per realizzare e applicare la nuova grafica dell'acquirente.
    </span>
  </div>
</div>

